export default {
  invisible: {
    visibility: 'hidden',
  },
};
